import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CreateProjectDropdown from '../../../components/DropdownStyle/CreateProjectDropdown';
import Select from '../../../components/ReactSelectDropdown';
import { filterOption } from '../../../components/ReactSelectDropdown/ReactSelectDropdown';
import SearchWithButton from '../../../components/Search/SearchWithButton';
import {
  FilterLabel,
  InputWithLabelSection,
} from '../../../styledComponents/common';
import { FilterContainer } from '../../../styledComponents/tasks';

const MasterTasksFilter = ({
  publicZoneList,
  getOfficesShortList,
  handleSearchByName,
  handleClearSearch,
  onFilterChange,
  officesShortList,
}) => {
  const { t } = useTranslation();
  const [selectedPublicZone, setSelectedPublicZone] = useState({
    label: t('all_public_zones'),
    value: null,
  });
  const [selectedOffice, setSelectedOffice] = useState({
    label: t('all_offices'),
    value: null,
  });
  const [masterTaskName, setMasterTaskName] = useState('');
  const [officeOptions, setOfficeOptions] = useState([
    {
      label: t('all_offices'),
      value: null,
    },
  ]);
  const [publicZoneOptions, setPublicZoneOptions] = useState([
    {
      label: t('all_public_zones'),
      value: null,
    },
  ]);

  useEffect(() => {
    if (publicZoneList && publicZoneList.length > 0) {
      const newArr = [
        {
          label: t('all_public_zones'),
          value: null,
        },
        ...publicZoneList.map(zone => ({
          label: zone.name,
          value: zone.id,
        })),
      ];
      setPublicZoneOptions(newArr);
    }
  }, [publicZoneList]);

  useEffect(() => {
    if (selectedPublicZone?.value) {
      getOfficesShortList({
        public_zone_id: selectedPublicZone.value,
      });
    } else {
      getOfficesShortList();
    }
    setSelectedOffice({
      label: t('all_offices'),
      value: null,
    });
  }, [selectedPublicZone, getOfficesShortList]);

  useEffect(() => {
    if (officesShortList) {
      const newArr = [
        {
          label: t('all_offices'),
          value: null,
        },
        ...(officesShortList || []).map(office => ({
          label: office.name,
          value: office.id,
        })),
      ];
      setOfficeOptions(newArr);

      // Reset selected office if it's not in the new options list
      if (selectedOffice && selectedOffice.value) {
        const officeExists = newArr.some(
          option => option.value === selectedOffice.value,
        );
        if (!officeExists) {
          setSelectedOffice({
            label: t('all_offices'),
            value: null,
          });
          updateFilters({
            ...getFilterState(),
            office: null,
          });
        }
      }
    }
  }, [officesShortList]);

  const getFilterState = () => ({
    publicZone: selectedPublicZone,
    office: selectedOffice,
    masterTaskName,
  });

  const updateFilters = filters => {
    if (onFilterChange) {
      onFilterChange(filters);
    }
  };

  const handlePublicZoneChange = zone => {
    setSelectedPublicZone(zone);
    updateFilters({
      ...getFilterState(),
      publicZone: zone,
      office: null,
    });
  };

  const handleOfficeChange = office => {
    setSelectedOffice(office);
    updateFilters({
      ...getFilterState(),
      office,
    });
  };

  const handleMasterTaskNameChange = name => {
    setMasterTaskName(name);
    updateFilters({
      ...getFilterState(),
      masterTaskName: name,
    });
  };

  const handleClearMasterTaskName = () => {
    setMasterTaskName('');
    updateFilters({
      ...getFilterState(),
      masterTaskName: '',
    });
    if (handleClearSearch) handleClearSearch();
  };

  return (
    <FilterContainer>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('public_zone')}</FilterLabel>
        <Select
          isSearchable
          value={selectedPublicZone}
          options={publicZoneOptions}
          placeholder={`${t('select_public_zone')}...`}
          onChange={handlePublicZoneChange}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('office')}</FilterLabel>
        <Select
          isSearchable
          value={selectedOffice}
          options={officeOptions}
          placeholder={`${t('select_office')}...`}
          onChange={handleOfficeChange}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <SearchWithButton
        itemName={t('master_task_name')}
        label={t('search_by_master_task_name')}
        searchTermName={t('master_task_name')}
        searchInput={masterTaskName}
        onInputChange={e => handleMasterTaskNameChange(e.target.value)}
        handleSearch={() =>
          handleSearchByName && handleSearchByName(masterTaskName)
        }
        handleClearSearch={handleClearMasterTaskName}
      />
    </FilterContainer>
  );
};

export default MasterTasksFilter;
